// extracted by mini-css-extract-plugin
export var ariaStatus = "copy-button-module--ariaStatus--Dq9uK";
export var container = "copy-button-module--container--6vDCM";
export var copyButton = "copy-button-module--copy-button--qIneP";